import script from "./IndexCourse.vue?vue&type=script&lang=ts&setup=true"
export * from "./IndexCourse.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__